import type { Template } from "@/types";

export const PO_06_H0_V6: Template[] = [
    {
        id: "po-06-h0v6-01",
        name: "PO 01 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 113, y: 200, width: 307, height: 515, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 200, width: 146, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 462, width: 146, height: 253, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 140, width: 388, height: 636, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 140, width: 197, height: 314, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 462, width: 197, height: 314, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-02",
        name: "PO 02 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 71, y: 184, width: 172, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 462, width: 172, height: 270, rotation: 0, imageRotation: 0 },
            { id: "3", x: 251, y: 184, width: 365, height: 548, rotation: 0, imageRotation: 0 },
            { id: "4", x: 758, y: 184, width: 365, height: 548, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1131, y: 184, width: 172, height: 270, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1131, y: 462, width: 172, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-03",
        name: "PO 03 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 140, width: 389, height: 636, rotation: 0, imageRotation: 0 },
            { id: "2", x: 450, y: 140, width: 184, height: 314, rotation: 0, imageRotation: 0 },
            { id: "3", x: 450, y: 462, width: 184, height: 314, rotation: 0, imageRotation: 0 },
            { id: "4", x: 793, y: 203, width: 306, height: 510, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 203, width: 161, height: 252, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1107, y: 463, width: 161, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-04",
        name: "PO 04 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 58, y: 240, width: 282, height: 436, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 240, width: 282, height: 436, rotation: 0, imageRotation: 0 },
            { id: "3", x: 744, y: 140, width: 423, height: 636, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1175, y: 140, width: 142, height: 207, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1175, y: 355, width: 142, height: 207, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1175, y: 570, width: 142, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-05",
        name: "PO 05 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 55, y: 240, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 462, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 204, y: 240, width: 279, height: 436, rotation: 0, imageRotation: 0 },
            { id: "4", x: 491, y: 240, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 491, y: 462, width: 141, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 687, y: 0, width: 687, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-06",
        name: "PO 06 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 140, width: 142, height: 207, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 355, width: 142, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 57, y: 570, width: 142, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 207, y: 140, width: 423, height: 636, rotation: 0, imageRotation: 0 },
            { id: "5", x: 744, y: 240, width: 284, height: 436, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1036, y: 240, width: 283, height: 436, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-07",
        name: "PO 07 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 687, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 739, y: 240, width: 283, height: 436, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1030, y: 240, width: 143, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1030, y: 462, width: 143, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1181, y: 240, width: 143, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1181, y: 462, width: 143, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-08",
        name: "PO 08 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 146, width: 473, height: 624, rotation: 0, imageRotation: 0 },
            { id: "2", x: 481, y: 146, width: 202, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 481, y: 462, width: 202, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 146, width: 202, height: 308, rotation: 0, imageRotation: 0 },
            { id: "5", x: 691, y: 462, width: 202, height: 308, rotation: 0, imageRotation: 0 },
            { id: "6", x: 901, y: 146, width: 473, height: 624, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h0v6-09",
        name: "PO 09 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 289, width: 223, height: 340, rotation: 0, imageRotation: 0 },
            { id: "2", x: 231, y: 289, width: 222, height: 340, rotation: 0, imageRotation: 0 },
            { id: "3", x: 461, y: 289, width: 222, height: 340, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 289, width: 223, height: 340, rotation: 0, imageRotation: 0 },
            { id: "5", x: 922, y: 289, width: 222, height: 340, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1152, y: 289, width: 222, height: 340, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "po-06-h0v6-10",
        name: "PO 10 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 48, y: 300, width: 207, height: 316, rotation: 0, imageRotation: 0 },
            { id: "2", x: 263, y: 300, width: 206, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 477, y: 300, width: 206, height: 316, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 300, width: 207, height: 316, rotation: 0, imageRotation: 0 },
            { id: "5", x: 906, y: 300, width: 206, height: 316, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1120, y: 300, width: 206, height: 316, rotation: 0, imageRotation: 0 }
        ],
    },

];

